import { StandardEvents } from '@shopify/events';

// Quantity remains Shopify's integer quantity: one item is one metre.
// This component only presents the total; Shopify calculates the payable cart.
class LengthTotal extends HTMLElement {
  #wrapper;
  #section;
  #request = 0;

  connectedCallback() {
    this.#wrapper = this.closest('.quantity-selector-wrapper');
    this.#section = this.closest('.shopify-section, dialog');
    this.#wrapper?.addEventListener('quantity-selector:update', this.#render);
    this.#wrapper?.addEventListener('input', this.#render);
    this.#wrapper?.addEventListener('change', this.#render);
    this.#section?.addEventListener(StandardEvents.productSelect, this.#variantUpdate);
    this.#render();
  }

  disconnectedCallback() {
    this.#wrapper?.removeEventListener('quantity-selector:update', this.#render);
    this.#wrapper?.removeEventListener('input', this.#render);
    this.#wrapper?.removeEventListener('change', this.#render);
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#variantUpdate);
    this.#request++;
  }

  #render = () => {
    const input = this.#wrapper?.querySelector('input[name="quantity"]');
    const quantity = Number(input?.value);
    const price = Number(this.dataset.price);
    const valid = input?.validity.valid && Number.isSafeInteger(quantity) && quantity > 0;
    const length = this.querySelector('[data-length]');
    const total = this.querySelector('[data-total]');
    if (!length || !total) return;
    length.textContent = valid ? String(quantity) : '—';
    const deliveryNote = this.querySelector('[data-delivery-note]');
    if (deliveryNote) {
      deliveryNote.textContent = valid
        ? `Se livrează într-o singură bucată de ${quantity} ${quantity === 1 ? 'metru' : 'metri'}.`
        : 'Se livrează într-o singură bucată, la lungimea selectată.';
    }
    if (!valid || !Number.isFinite(price)) {
      total.textContent = '—';
      return;
    }
    const currency = this.dataset.currency || 'RON';
    const withCode = this.dataset.currencyCode === 'true';
    const formatter = new Intl.NumberFormat(this.dataset.locale || 'ro-RO', {
      style: 'currency', currency, currencyDisplay: withCode ? 'code' : 'symbol',
      minimumFractionDigits: 2, maximumFractionDigits: 2,
    });
    let formatted = formatter.format((price * quantity) / 100);
    if (currency === 'RON' && !withCode) formatted = formatted.replace('RON', 'lei');
    total.textContent = formatted;
  };

  #variantUpdate = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || request !== this.#request || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const fresh = [...detail.html.querySelectorAll('lt-length-total')]
        .find((element) => element.dataset.productId === this.dataset.productId);
      if (!fresh) return;
      this.dataset.price = fresh.dataset.price;
      this.dataset.variantId = fresh.dataset.variantId;
      this.#render();
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[length-total] Variant update failed:', error);
    });
  };
}

if (!customElements.get('lt-length-total')) customElements.define('lt-length-total', LengthTotal);
